/* tslint:disable */
/* eslint-disable */
/**
 * SISCC Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ItemState,
    ItemStateFromJSON,
    ItemStateFromJSONTyped,
    ItemStateToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChangeConfigResponse
 */
export interface ChangeConfigResponse {
    /**
     * 
     * @type {Array<ItemState>}
     * @memberof ChangeConfigResponse
     */
    items: Array<ItemState>;
    /**
     * 
     * @type {string}
     * @memberof ChangeConfigResponse
     */
    configurationString: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChangeConfigResponse
     */
    added: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChangeConfigResponse
     */
    removed: Array<string>;
}

export function ChangeConfigResponseFromJSON(json: any): ChangeConfigResponse {
    return ChangeConfigResponseFromJSONTyped(json, false);
}

export function ChangeConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeConfigResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ItemStateFromJSON)),
        'configurationString': json['configurationString'],
        'added': json['added'],
        'removed': json['removed'],
    };
}

export function ChangeConfigResponseToJSON(value?: ChangeConfigResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ItemStateToJSON)),
        'configurationString': value.configurationString,
        'added': value.added,
        'removed': value.removed,
    };
}


